import * as React from 'react'

interface OwnProps {
  children: any
  className?: string
  onClickOutside: any
  isRendered: boolean
  isListItemType?: boolean
  role?: string
  stopPropagation?: boolean
}

type Props = OwnProps

class OutsideClick extends React.Component<Props, {}> {
  refDiv: React.RefObject<HTMLDivElement>
  refUl: React.RefObject<HTMLUListElement>

  constructor(props) {
    super(props)
    this.refDiv = React.createRef()
    this.refUl = React.createRef()
  }

  componentDidUpdate(prevProps, prevState) {
    const { stopPropagation = true } = this.props
    if (this.props.isRendered) {
      document.addEventListener('click', this.handleOutsideClick, stopPropagation)
    } else {
      document.removeEventListener('click', this.handleOutsideClick, stopPropagation)
    }
  }

  handleOutsideClick = e => {
    const { isListItemType = false } = this.props
    const { current } = isListItemType ? this.refUl : this.refDiv
    if (!current) {
      return
    }

    const { isRendered, onClickOutside } = this.props
    if (current.contains(e.target)) {
      return
    }

    if (isRendered) {
      onClickOutside(e)
      const { stopPropagation = true } = this.props
      if (stopPropagation) {
        e.stopPropagation()
        e.preventDefault()
      }
    }
  }

  render() {
    const { className, isRendered, role, isListItemType = false } = this.props
    if (!isRendered) {
      return null
    }

    return (
      <>
        {isListItemType ? (
          <ul role={role} className={className} ref={this.refUl}>
            {this.props.children}
          </ul>
        ) : (
          <div className={className} ref={this.refDiv}>
            {this.props.children}
          </div>
        )}
      </>
    )
  }
}

export default OutsideClick
